export const CONTACT = {
  phone: "9625325414",
  phoneDisplay: "+91 96253 25414",
  whatsapp: "919625325414",
  email: "thermoedgeinsulation@gmail.com",
  tagline: "Smart Insulation. Strong Protection.",
  coverage: "Bihar → Pan India",
};

export const openWhatsApp = (
  message = "Hi Thermo Edge, I'd like a free quote for insulation.",
) => {
  const url = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const INDUSTRIES = [
  "Warehouses",
  "Factories",
  "Poultry Farms",
  "Logistics Facilities",
  "Commercial Buildings",
  "Residential Buildings",
  "Industrial Sheds",
  "Cold Storage",
];

export const USPS = [
  "Premium Quality Products",
  "Expert Technical Support",
  "Professional Installation",
  "Fast & Reliable Delivery",
  "Competitive Pricing",
  "Customized Solutions",
  "Energy-Efficient Materials",
  "25+ Year Lifespan",
  "Free Site Inspection",
  "Dedicated Support",
];

export const SERVICES = [
  {
    num: "01",
    title: "Product Supply",
    blurb:
      "Genuine, tested insulation stocked and delivered — no aftermarket surprises.",
  },
  {
    num: "02",
    title: "Professional Installation",
    blurb:
      "Certified crews, tape-sealed joints, and post-monsoon inspection on every job.",
  },
  {
    num: "03",
    title: "Technical Consultation",
    blurb:
      "Load calculation, specification and drawings tailored to your building envelope.",
  },
  {
    num: "04",
    title: "Free Site Inspection",
    blurb: "An engineer on your roof within 48 hours. No commitment. No fee.",
  },
  {
    num: "05",
    title: "After-Sales Support",
    blurb:
      "Workmanship warranty, monsoon follow-up, and priority response for repairs.",
  },
];

export const PROCESS = [
  {
    num: "01",
    title: "Enquiry",
    text: "You send a message. We call back within business hours.",
  },
  {
    num: "02",
    title: "Site Inspection",
    text: "Engineer visits, measures, documents heat load — no fee.",
  },
  {
    num: "03",
    title: "Proposal",
    text: "Written specification and firm quote within 48 hours.",
  },
  {
    num: "04",
    title: "Supply & Install",
    text: "Materials on-site, crew mobilised, joints sealed clean.",
  },
  {
    num: "05",
    title: "Handover",
    text: "Walk-through, warranty, and a scheduled monsoon check-in.",
  },
];
